'use strict';

wbApp.factory('courseScheduleSvc', ['$resource', '$cacheFactory', 'repositorySvc', 'semesterSvc', '$q',
    function ($resource, $cacheFactory, repositorySvc, semesterSvc, $q) {

        var CourseSchedule = $resource('/Api/CourseSchedule/Get/:id', {}, {
            'query': { method: 'GET', isArray: true },
            'update': { method: 'POST', url: '/Api/CourseSchedule/Update' },
            'insert': { method: 'POST', url: '/Api/CourseSchedule/Insert' },
            'delete': { method: 'POST', url: '/Api/CourseSchedule/Delete' },
            'getSingle' : { method: 'GET', url: '/Api/CourseSchedule/GetSingle' },
            'getPattern': { method: 'GET', url: '/Api/CourseSchedule/GetPatternByOccurence' },
            'getAllForSemester': { method: 'GET', isArray: true, url: '/Api/UserSchedule/GetAllForSemester' },
            'getAllForSemesterAll': { method: 'GET', isArray: true, url: '/Api/UserSchedule/GetAllForSemesterAll' },
            'getAllForCurrentUserAndCourse': { method: 'GET', isArray: true, url: '/Api/UserSchedule/GetAllForCurrentUserAndCourse' },
            'expandRecurrencePattern': { method: 'POST', isArray: true, url: '/Api/CourseSchedule/ExpandRecurrencePattern' },

        });

        var cache = $cacheFactory('courseScheduleSvcCache');
        var cachedCourseID = 0;
        var cachedIncludeDeleted = false;

        function expandRecurrencePattern(model) {
            return repositorySvc.customPost(
                'expandRecurrencePattern',
                CourseSchedule,
                model,
                null,
                null,
                true);
        }

        function getAllSortedAsync(courseID, refresh, includeDeleted) {
            let res = [];
            res.$promise = $q(function (resolve, reject) {
                getAllAsync(courseID, refresh, includeDeleted).$promise.then(function (schedules) {
                    res.push.apply(res, _.sortBy(schedules, 'startDate'));
                    resolve(res);
                }, function (rejectReason) {
                    reject(rejectReason);
                });
            });
            
            return res;
        }
        
        function getAllAsync(courseID, refresh, includeDeleted) {
            if (!courseID) {
                return null;
            }

            var models = cache.get('schedules');

            if (cachedCourseID !== courseID || !models || refresh || (cachedIncludeDeleted !== !!includeDeleted)) {
                models = repositorySvc.get(CourseSchedule, { courseID: courseID, includeDeletes: !!includeDeleted });
                cache.put('schedules', models);
                cachedCourseID = courseID;
                cachedIncludeDeleted = !!includeDeleted;
            }

            return models;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                CourseSchedule,            // $resource
                cache.get('schedules'),    // collection
                {
                    model: data
                },                         // entity
                successCallback,
                errorCallback,
                'courseScheduleID');
        }

        function update(data, notificationSetting, successCallback, errorCallback) {
            repositorySvc.update(
                CourseSchedule,                   // $resource
                cache.get('schedules'),           // collection
                {
                    model: data,
                    sendEmailNotification: notificationSetting.sendEmailNotification,
                    sendSmsNotification: notificationSetting.sendSmsNotification
                },                                // entity
                successCallback,
                errorCallback,
                'courseScheduleID');
        }

        function remove(data, notificationSetting, successCallback, errorCallback) {
            repositorySvc.remove(
                CourseSchedule,                            // $resource
                cache.get('schedules'),                    // collection
                { courseScheduleID: data.courseScheduleID },           // entity
                successCallback,
                errorCallback,
                {
                    courseScheduleID: data.courseScheduleID,
                    sendEmailNotification: notificationSetting.sendEmailNotification,
                    sendSmsNotification: notificationSetting.sendSmsNotification
                },
                'courseScheduleID');
        }

        function getPattern(courseID, courseScheduleID) {
            return repositorySvc.customGet('getPattern', CourseSchedule, {
                courseID: courseID,
                courseScheduleID: courseScheduleID
            });
        }

        function getSingle(courseScheduleID) {
            return repositorySvc.customGet('getSingle', CourseSchedule, {               
                courseScheduleID: courseScheduleID
            });
        }

        function getAllForSemesterAsync(semesterID, compensationGroupID, userID, startDate, endDate) {
            return repositorySvc.customGet('getAllForSemester', CourseSchedule, {
                semesterID: semesterID,
                compensationGroupID: compensationGroupID,
                userID: userID,
                startDate: startDate,
                endDate: endDate
            });
        }

        function getAllForSemesterAllAsync(semesterID, compensationGroupID, userID, startDate, endDate) {
            return repositorySvc.customGet('getAllForSemesterAll', CourseSchedule, {
                semesterID: semesterID,
                compensationGroupID: compensationGroupID,
                userID: userID,
                startDate: startDate,
                endDate: endDate
            });
        }

        function getAllForCurrentUserAndCourse(courseID) {
            return repositorySvc.customGet('getAllForCurrentUserAndCourse', CourseSchedule, {
                courseID: courseID
            });
        }

        function updateEventByStartDate(event, startDate) {
            if (event.recurrenceInfo) {
                event.recurrenceInfo.start = startDate;
                event.recurrenceInfo.weekDays = weekDaysFromDate(startDate);
            };
        }

        function weekDaysFromDate(date) {
            var dayNumber = moment(date).day();

            if (!dayNumber) {
                return 1;
            }

            return (1 << dayNumber);
        }

        function createNew(courseModel, isNewRecurrence, callback) {

            var mStartDate = courseModel.firstLesson
                ? moment().startOf('day')
                    .add(moment(courseModel.firstLesson).hour(), 'h')
                    .add(moment(courseModel.firstLesson).minute(), 'm')
                : moment().startOf('hour');

            var mEndDate = courseModel.lessonLengthInMinutes
                ? moment(mStartDate).add(courseModel.lessonLengthInMinutes, 'm')
                : moment(mStartDate).add(60, 'm');

            var newEvent = {
                semesterID: courseModel.semesterID,
                courseID: courseModel.courseID,
                employeeID: courseModel.employeeID,
                teacherIds: courseModel.teacherIds,
                classroomID: courseModel.classroomID || undefined,
                capacity: courseModel.capacity,
                startDate: mStartDate.toDate(),
                endDate: mEndDate.toDate(),
                subjectCategoryID: courseModel.subjectCategoryID,
                recurrenceType: !!isNewRecurrence ? 1 : 0
            }

            if (!!isNewRecurrence) {
                newEvent.recurrenceInfo = {
                    type: 1,
                    periodicity: 1,
                    weekDays: weekDaysFromDate(mStartDate.toDate()),
                    occurrenceCount: 10,
                    start: mStartDate.toDate(),                   
                    range: 1
                };
                newEvent.recurrenceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });

                semesterSvc.getDefaultAsync().then(function (sem) {
                    newEvent.recurrenceInfo.end = sem.endDate;
                    if (!!callback) {
                        callback(newEvent);
                    }
                });
            }

            return newEvent;
        }

        function createNewEvent(
            startDate,
            endDate,
            classroomID,
            semesterID) {

            var newEvent = {
                subjectCategoryID: 2,
                startDate: startDate,
                endDate: endDate,
                classroomID: classroomID,
                semesterID: semesterID,
                employeeID: 0,
                courseID: 0,
            };

            return newEvent;
        }

        function createNewCourse(
            startDate,
            endDate,
            classroomID,
            semesterID,
            isNewRecurrence) {

            var newEvent = {
                subjectCategoryID: 1,
                startDate: startDate,
                endDate: endDate,
                classroomID: classroomID,
                semesterID: semesterID,
                employeeID: 0,
                courseID: 0,
                recurrenceType: !!isNewRecurrence ? 1 : 0
            };

            if (!!isNewRecurrence) {
                newEvent.recurrenceInfo = {
                    type: 1,
                    periodicity: 1,
                    weekDays: weekDaysFromDate(startDate),
                    occurrenceCount: 10,
                    start: startDate,
                    range: 1
                };
                newEvent.recurrenceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }

            return newEvent;
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            createNewEvent: createNewEvent,
            createNewCourse: createNewCourse,
            getPattern: getPattern,
            getSingle: getSingle,
            getAllForSemesterAsync: getAllForSemesterAsync,
            getAllForSemesterAllAsync: getAllForSemesterAllAsync,
            updateEventByStartDate: updateEventByStartDate,
            getAllForCurrentUserAndCourse: getAllForCurrentUserAndCourse,
            expandRecurrencePattern: expandRecurrencePattern,
            getAllSortedAsync: getAllSortedAsync
        }
    }
]);